import { EventPayloads, EventType } from "./events"

class EventBus {
  private subscribers: Record<string, ((payload: any) => void)[]> = {}

  // 订阅事件
  on<T extends EventType>(eventName: T, callback: (payload: EventPayloads[T]) => void) {
    if (!this.subscribers[eventName]) {
      this.subscribers[eventName] = []
    }
    this.subscribers[eventName].push(callback)
  }

  // 发布事件
  emit<T extends EventType>(eventName: T, payload: EventPayloads[T]) {
    if (this.subscribers[eventName]) {
      this.subscribers[eventName].forEach((callback) => callback(payload))
    }
  }

  // 取消订阅
  off<T extends EventType>(eventName: T, callback: (payload: EventPayloads[T]) => void) {
    if (this.subscribers[eventName]) {
      this.subscribers[eventName] = this.subscribers[eventName].filter(
        (cb) => cb !== callback,
      )
    }
  }
}

export const eventBus = new EventBus()
